import React from "react";
import "./style.css";

function Footer() {
    return (
        <footer class="pt-4">Copyright ©2019 Maintain</footer>
    );
}
export default Footer;